/* eslint-disable new-cap */
/* eslint-disable no-invalid-this */
/* eslint-disable react/prop-types */
/* eslint-disable require-jsdoc */
import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { BrowserRouter as Router } from 'react-router-dom';

// import PageCollection from '../PageCollection/';
import PageForgotPassword from '../PageForgotPassword/';
import PageResetPassword from '../PageResetPassword/';
import PageRaffleHomepage from '../PageRaffleHomePage';
import PageUserDashboard from '../PageUserDashboardTPO';
import PageUserDashboardMobile from '../PageUserDashboardTPO/index-mobile';
import PageShoppingCart from '../PageShoppingCart';
import PageHelps from '../PageHelps/';
import PageEmailVerification from '../PageEmailVerification';
import PageHome from '../PageHome';
import PageLogin from '../PageLogin/';
// import PageProductDetails from "../PageProductDetails/PageProductDetailsV2";
import PageProductDetails from '../PageProductDetailsTPO';
// import PageInvoice from "../PageInvoice";
import PageInvoiceTPO from '../PageInvoiceTPO';
import PageRegister from '../PageRegister/';
import PageCheckout from '../PageCheckout/';
import PageOffer from '../PageOffer/';
import PagePaymentConfirm from '../PagePaymentConfirm';
import PagePaymentKredivo from '../PagePaymentKredivo';
import PagePaymentAkulaku from '../PagePaymentAkulaku';
import PagePaymentResult from '../PagePaymentResult';
import PageForgotPasswordSuccess from '../PageHome/Section/PageForgotPasswordSuccess';
import PagePaymentAtome from '../PagePaymentAtome';
import PageSelectedCategory from '../PageSelectedCategory';
import NotFound from '../NotFound';
import PageMaintenance from '../PageMaintenance';
import PageSpinningWheel from '../PageSpinningWheel';
import PageApp from '../PageApp';
import PageConcierge from '../PageConcierge';
import PageDisbursementConfirmation from '../PageDisbursementConfirmation';
import PageResetPasswordV3 from '../PageHome/Section/PageResetPasswordV3';
import PageFlashSale from '../PageFlashSale';
import Route from './Route';
import moment from 'moment';
import PageRegisterV3 from '../PageHome/Section/PageRegisterV3';
import PageLoginV3 from '../PageHome/Section/PageLoginV3';
import PageForgotPasswordV3 from '../PageHome/Section/PageForgotPasswordV3';
import SellerRegistration from '../PageSellerRegistration';
import { connect } from 'react-redux';
import { setLoginReferral } from '../../actions/loginReferralAction';

// @daniel
import PageSearchDetails from '../PageSearchDetails';
import BrandPage from '../BrandPage';
import PageSearchDetailsTPO from '../PageSearchDetailsTPO';
import {
  NeverTooLavishPage,
  HotProducts,
  TrendingNow,
  BestSelling,
  Upcoming,
  PriceDrop,
  RaffleCommonGround,
  CollectionPage,
} from '../../Container';

import {
  RaffleSelectSneakers,
  RaffleSuccess,
} from '../../Container/RaffleCommonGround/RaffleChild';

import {
  CommonGroundLogin,
  ParticipateForm,
  SuccessPage,
} from '../../Container/CommonGroundPage';

import {
  RafflePreview,
  RaffleDetailNovembazar,
  RaffleTermOfService,
} from '../../Container/KickFair';

import { APP_ID } from '../../utils/Constants';
import {
  LocalBrandsProduct,
  SpecialDealsProduct,
  SurpriseDropProduct,
  ExclusiveLaunchProduct,
  MadeInIndonesiaDetailPage,
  CollectionProductListPage,
} from '../PageHome/kickAvenueFair';

import LuxuryBrandPage from '../PageHome/Luxury/LuxuryBrandPage';
import OrderSaya from '../PageUserDashboardTPO/OrderSaya';
import Penjualan from '../PageUserDashboardTPO/Penjualan';
import ProfileSettings from '../PageUserDashboardTPO/ProfileSettings';
import SellRequest from '../PageUserDashboardTPO/SellRequest';
import WalletHistory from '../PageUserDashboardTPO/WalletHistory';
import SellerCreditHistory from '../PageUserDashboardTPO/SellerCreditHistory';
import OfferHistory from '../PageUserDashboardTPO/OfferHistory';
import SKURequest from '../PageUserDashboardTPO/SKURequest';
import PointInfo from '../PageUserDashboardTPO/PointInfo';
import MyRewards from '../PageUserDashboardTPO/MyRewards';
import PageSprintAsiaResult from '../PageSprintAsiaResult';

import Amplify, {
  Analytics as AnalyticsAmplify,
  AmazonPersonalizeProvider,
} from 'aws-amplify';
import { AmplifyConfig, PersonalizeConfig } from '../../constants';
import Home from 'Pages/Home';

/* Kickavenews Route */
import Blog from 'Pages/Blog';
import Article from 'Pages/Blog/Components/Pages/Article';
import Calendar from 'Pages/Blog/Components/Pages/Calendar';
import PostsListPage from 'Pages/Blog/Components/Pages/PostsListPage';
import SearchResult from 'Pages/Blog/Components/Pages/SearchResult';
import SearchResultTag from 'Pages/Blog/Components/Pages/SearchResultTag';
/* End of Kickavenews Route */

import { ModalPopupBanner } from '../Modals';
import Brand from 'Pages/Brand';
import { UserDashboardConsignment } from 'Pages/UserDashboard';
import ConsignmentRequest from 'Pages/UserDashboard/ConsignmentRequest/ConsignmentRequest';

const routes = [
  {
    component: PageApp,
    routes: [
      {
        exact: true,
        path: '/email-verification/:token',
        component: PageEmailVerification,
      },

      {
        exact: true,
        path: '/kickavenews',
        component: Blog,
      },

      {
        exact: true,
        path: '/kickavenews/search/:keyword',
        component: SearchResult,
      },
      {
        exact: true,
        path: '/kickavenews/tag/:tag',
        component: SearchResultTag,
      },
      {
        exact: true,
        path: '/kickavenews/calendar',
        component: Calendar,
      },

      {
        exact: true,
        path: '/kickavenews/latest',
        component: PostsListPage,
      },

      {
        exact: true,
        path: '/kickavenews/fashion',
        component: PostsListPage,
      },

      {
        exact: true,
        path: '/kickavenews/popular',
        component: PostsListPage,
      },

      {
        exact: true,
        path: '/kickavenews/luxury',
        component: PostsListPage,
      },
      {
        exact: true,
        path: '/kickavenews/sneakers',
        component: PostsListPage,
      },

      {
        exact: true,
        path: '/kickavenews/:slug',
        component: Article,
      },

      {
        exact: true,
        path: '/spinthewheel',
        component: PageSpinningWheel,
      },
      {
        exact: true,
        path: '/shopping-cart',
        component: PageShoppingCart,
      },
      {
        exact: true,
        path: '/reset-password/:token',
        component: PageResetPasswordV3,
      },
      {
        exact: true,
        path: '/disbursement_confirmation/:token',
        component: PageDisbursementConfirmation,
      },
      {
        exact: true,
        path: '/forgot-password/success',
        component: PageForgotPasswordSuccess,
      },
      {
        exact: true,
        path: '/reset-password/auth/success',
        component: PageForgotPasswordSuccess,
      },
      // {
      //   exact: true,
      //   path: "/forgot-password",
      //   component: PageForgotPassword
      // },
      {
        exact: true,
        path: '/forgot-password',
        component: PageForgotPasswordV3,
      },
      {
        path: '/helps',
        component: PageHelps,
      },
      // {
      //   exact: true,
      //   path: "/login",
      //   component: PageLogin
      // },
      {
        exact: true,
        path: '/login',
        component: PageLoginV3,
      },
      // {
      //    path:'/sneakers/:id/:slug/checkout',
      //    component:PageCheckout
      // },
      // {
      //   // exact:true,
      //   path: '/:category/:id/:slug',
      //   component: PageProductDetails
      // },
      // {
      //   exact: true,
      //   path: "/register",
      //   component: PageRegister
      // },
      {
        exact: true,
        path: '/register',
        component: PageRegisterV3,
      },
      {
        exact: true,
        path: '/payment_confirmation/:invoice?',
        component: PagePaymentConfirm,
      },
      {
        exact: true,
        path: '/payments/akulaku',
        component: PagePaymentAkulaku,
      },
      {
        exact: true,
        path: '/payments/kredivo',
        component: PagePaymentKredivo,
      },
      {
        exact: true,
        path: '/payments/sprintasia',
        component: PageSprintAsiaResult,
      },
      {
        exact: true,
        path: '/payments/results',
        component: PagePaymentResult,
      },
      {
        exact: true,
        path: '/',
        component: Home,
      },
      {
        exact: true,
        path: '/invoices/:invoice',
        // component: PageInvoice
        component: PageInvoiceTPO,
      },
      {
        exact: true,
        path: '/payment_confirmation/:invoice?',
        component: PagePaymentConfirm,
      },
      {
        exact: true,
        path: '/payments/kredivo',
        component: PagePaymentKredivo,
      },
      {
        exact: true,
        path: '/payments/atome',
        component: PagePaymentAtome,
      },
      {
        exact: true,
        path: '/sell-request',
        component: SellRequest,
      },
      {
        exact: true,
        path: '/sell-request/:id',
        component: SellRequest,
      },
      {
        exact: true,
        path: '/consignment-request',
        component: ConsignmentRequest,
      },
      {
        exact: true,
        path: '/consignment-request/:id',
        component: ConsignmentRequest,
      },
      {
        exact: true,
        path: '/sku-request',
        component: SKURequest,
      },
      {
        exact: true,
        path: '/seller-registration',
        component: SellerRegistration,
      },
      {
        exact: true,
        path: '/user_dashboard',
        component: PageUserDashboardMobile,
      },
      {
        exact: true,
        path: '/user_dashboard/:options',
        component: PageUserDashboard,
        routes: [
          {
            exact: true,
            path: '/user_dashboard/order',
            component: OrderSaya,
          },
          {
            exact: true,
            path: '/user_dashboard/sale',
            component: Penjualan,
          },
          {
            exact: true,
            path: '/user_dashboard/profile-settings',
            component: ProfileSettings,
          },
          {
            exact: true,
            path: '/user_dashboard/wallet-history',
            component: WalletHistory,
          },
          {
            exact: true,
            path: '/user_dashboard/seller-history',
            component: SellerCreditHistory,
          },
          {
            exact: true,
            path: '/user_dashboard/offer-history',
            component: OfferHistory,
          },
          {
            exact: true,
            path: '/user_dashboard/point-info',
            component: PointInfo,
          },
          {
            exact: true,
            path: '/user_dashboard/rewards',
            component: MyRewards,
          },
          {
            exact: true,
            path: '/user_dashboard/consignment',
            component: UserDashboardConsignment,
          },
        ],
      },
      {
        exact: true,
        path: '/nevertoolavish/:custom',
        component: NeverTooLavishPage,
      },
      {
        exact: true,
        path: '/promo/reactxdisruptor/:options?',
        component: RaffleCommonGround,
        routes: [
          // {
          //    exact: true,
          //    path: '/promo/reactxdisruptor/auth',
          //    component: RaffleAuth
          // },
          {
            exact: true,
            path: '/promo/reactxdisruptor/submit-sneakers',
            component: RaffleSuccess,
          },
          {
            exact: true,
            path: '/promo/reactxdisruptor',
            component: RaffleSelectSneakers,
          },
        ],
      },
      {
        exact: true,
        path: '/promo/common-grounds/',
        component: ParticipateForm,
      },
      {
        exact: true,
        path: '/promo/common-grounds/success-page/',
        component: SuccessPage,
      },
      {
        exact: true,
        path: '/promo/common-grounds/auth',
        component: CommonGroundLogin,
      },
      {
        exact: true,
        path: '/404',
        component: NotFound,
      },
      {
        exact: true,
        path: '/maintenance',
        component: PageMaintenance,
      },
      {
        exact: true,
        path: '/browse-all',
        component: PageSearchDetails,
      },
      {
        exact: true,
        path: '/search',
        component: PageSearchDetails,
      },
      {
        exact: true,
        path: '/trending',
        component: PageSearchDetails,
      },
      {
        exact: true,
        path: '/best-selling',
        component: PageSearchDetails,
      },
      {
        exact: true,
        path: '/hot-products',
        component: PageSearchDetails,
      },
      {
        exact: true,
        path: '/price-drop',
        component: PageSearchDetails,
      },
      {
        exact: true,
        path: '/search/:category',
        component: PageSearchDetails,
      },
      {
        exact: true,
        path: '/search/:keyword',
        component: PageSearchDetails,
      },
      {
        exact: true,
        path: '/collection/:slug',
        component: PageSearchDetails,
      },
      // {
      //   exact: true,
      //   path: '/:category/:brand-slug',
      //   component: BrandPage,
      // },
      {
        path: '/:category',
        component: PageSelectedCategory,
        routes: [
          // {
          //   exact: true,
          //   // path: '/:category/search',
          //   path: '/search/:category',
          //   component: PageSearchDetails,
          // },
          // {
          //   exact: true,
          //   // path: '/:category//search:keyword',
          //   path: '/search/:category/:keyword',
          //   component: PageSearchDetails,
          // },
          {
            exact: true,
            path: '/:category/raffle-homepage',
            component: PageRaffleHomepage,
          },
          {
            exact: true,
            path: '/:category/hot-products',
            // component: HotProducts,
            component: PageSearchDetails,
          },
          {
            exact: true,
            path: '/:category/brands',
            component: LuxuryBrandPage,
          },
          {
            exact: true,
            path: '/:category/flash-sale',
            component: PageFlashSale,
          },
          {
            exact: true,
            path: '/:category/tahi-lalats',
            component: CollectionProductListPage,
          },
          {
            exact: true,
            path: '/:category/local-brands',
            component: MadeInIndonesiaDetailPage,
          },
          {
            exact: true,
            path: '/:category/collection/:slug',
            // component: CollectionPage,
            component: PageSearchDetails,
          },
          {
            exact: true,
            path: '/:category/most-popular',
            // component: BestSelling,
            component: PageSearchDetails,
          },
          {
            exact: true,
            path: '/:category/best-selling',
            // component: BestSelling,
            component: PageSearchDetails,
          },
          {
            exact: true,
            path: '/:category/for-you',
            component: PageSearchDetails,
          },
          {
            exact: true,
            path: '/:category/upcoming',
            component: Upcoming,
          },
          {
            exact: true,
            path: '/:category/concierge',
            component: PageConcierge,
          },
          {
            exact: true,
            path: '/:category/price-drop',
            component: PriceDrop,
          },
          {
            exact: true,
            path: '/:category/raffle-preview',
            component: RafflePreview,
          },
          {
            exact: true,
            path: '/:category/raffle/:slug',
            component: RaffleDetailNovembazar,
          },
          {
            exact: true,
            path: '/:category/raffle/:slug/tos',
            component: RaffleTermOfService,
          },
          {
            path: '/:category/:id/:slug',
            component: PageProductDetails,
          },
          {
            exact: true,
            path: '/:category/indonesian-brands',
            component: LocalBrandsProduct,
          },
          {
            exact: true,
            path: '/:category/surprise-drop',
            component: SurpriseDropProduct,
          },
          {
            exact: true,
            path: '/:category/exclusive-release',
            component: ExclusiveLaunchProduct,
          },
          {
            exact: true,
            path: '/:category/special-deals',
            component: SpecialDealsProduct,
          },
          {
            exact: true,
            path: '/:category/local-brands',
            component: MadeInIndonesiaDetailPage,
          },
          {
            exact: true,
            path: '/:category/:slug',
            component: BrandPage,
          },
          // {
          //   exact: true,
          //   path: '/:category/:slug',
          //   component: PageSearchDetails,
          // },
          {
            component: PageHome,
          },
        ],
      },
      {
        component: NotFound,
      },
    ],
  },
];

class AppRoute extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount = () => {
    const currentUrl = window.location.pathname;
    this._setLoginReferral();
    this._connectIntercom();
    this.handleCampaignId();
    this.initAmplify();
  };

  initAmplify = () => {
    AnalyticsAmplify.addPluggable(new AmazonPersonalizeProvider());
    Amplify.configure(PersonalizeConfig);
    Amplify.configure(AmplifyConfig);
  };

  handleCampaignId = () => {
    const currentUrl = window.location.href;
    const isClickThroughURL = currentUrl.includes('#');

    if (isClickThroughURL) {
      const facebook_ad_campaign = currentUrl.split('#')[1];
      localStorage.setItem(
        'facebook_ad_campaign',
        JSON.stringify({ facebook_ad_campaign }),
      );
    }
  };

  _connectIntercom = () => {
    if (window.Intercom) {
      const { userdata, isLogged } = this.props.dataAuth;

      const timestamp = moment(Date.now());
      const unixTimestamp = timestamp.unix();

      if (isLogged && userdata.id) {
        window.Intercom('boot', {
          app_id: APP_ID,
          email: userdata.typed_email,
          created_at: unixTimestamp,
          name:
            userdata.first_name === null
              ? userdata.typed_email
              : (userdata.first_name + ' ' + userdata.family_name).trim(),
          user_id: userdata.id,
        });
      }
    }
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.dataAuth.userdata.isFetch &&
      prevProps.dataAuth.userdata.isFetch !==
        this.props.dataAuth.userdata.isFetch
    ) {
      this._connectIntercom();
    }
    if (
      prevProps.dataAuth.isLogged &&
      prevProps.dataAuth.isLogged !== this.props.dataAuth.isLogged
    ) {
      if (window.Intercom) {
        window.Intercom('shutdown');
        window.Intercom('boot', {
          app_id: APP_ID,
        });
      }
    }
  }

  _setLoginReferral = () => {
    const documentReferral = document.referrer;
    const userAgent = navigator.userAgent;

    const isReferralFromInternalSite = /168|localhost|kickavenue/i.test(
      documentReferral,
    );

    const isRefferalFrom = /telegram|whatsapp|facebook|instagram|twitter/i.test(
      documentReferral,
    );
    const isUserAgentFromApp =
      /telegram|whatsapp|facebook|instagram|twitter/i.test(userAgent);

    const isInWebApp = isRefferalFrom || isUserAgentFromApp;

    if (!isReferralFromInternalSite || isInWebApp) {
      this.props.setLoginReferral(isInWebApp);
    }
  };

  render() {
    return (
      <Router>
        <div>
          {routes.map((route, i) => (
            <Route key={i} {...route} />
          ))}
        </div>
        <ModalPopupBanner />
      </Router>
    );
  }
}

const mapStateToProps = ({ dataAuth }) => ({
  dataAuth,
});
const mapDispatchToProps = (dispatch) => ({
  setLoginReferral: (data) => dispatch(setLoginReferral(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppRoute);

export { Route, routes };
